
<template>
  <div>
    <b-container fluid="lg">
      <b-row>
        <b-col>
          <b-card>
            <div class="text-center mb-3">
              <img class="mb-3 logo" src="/imgs/logoAbelha.png" alt="" />
            </div>
            <b-skeleton-wrapper :loading="firstLoading">
              <template #loading>
                <b-card>
                  <b-row>
                    <b-skeleton width="100%"></b-skeleton>
                  </b-row>
                  <b-row class="mt-3">
                    <b-skeleton height="40%" width="100%"></b-skeleton>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col>
                      <b-skeleton type="input" width="50%"></b-skeleton>
                    </b-col>
                    <b-col>
                      <b-skeleton type="input" width="50%"></b-skeleton>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col>
                      <b-skeleton type="input" width="50%"></b-skeleton>
                    </b-col>
                    <b-col>
                      <b-skeleton type="input" width="50%"></b-skeleton>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col>
                      <b-skeleton-img width="50%"></b-skeleton-img>
                    </b-col>
                    <b-col>
                      <b-skeleton-img width="50%"></b-skeleton-img>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-skeleton width="100%"></b-skeleton>
                  </b-row>
                </b-card>
              </template>
              <div class="text-center mt-3">
                <h2 class="mt-3 distribuidor">Olá {{ distribuidor.nome }}</h2>
              </div>
              <h4 class="mt-3 mb-3 title">Com o intuito de manter atualizado o cadastro dos nossos clientes, necessitamos
                que preencha
                alguns dados neste formulário!</h4>
              <b-row class="mt-3 mb-3">
                <h5>Código do Distribuidor: {{ distribuidor.codigo }}</h5>
              </b-row>
              <b-row class="mt-3">
                <b-col>
                  <label for="nome"><span>*</span> Nome do Responsável:</label>
                  <b-form-input id="nome" v-model="responsavel" placeholder="Nome"></b-form-input>
                </b-col>
                <b-col>
                  <label for="nome"><span>*</span> CPF do Responsável:</label>
                  <b-form-input :state="cpfState" id="nome" v-model="cpf" v-mask="['###.###.###-##']"
                    placeholder="CPF"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col>
                  <label for="email"><span>*</span> E-mail:</label>
                  <b-form-input :state="emailState" id="email" v-model="email" placeholder="E-mail"></b-form-input>
                </b-col>
                <b-col>
                  <label for="data"><span>*</span> Data de Nascimento do Responsável:</label>
                  <b-form-input type="date" id="data" v-model="nascimento"></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-card>
                    <span>*</span> Telefone Principal:
                    <b-form-input class="mt-3" v-mask="['(##) ####-####', '(##) #####-####']" id="telefone1"
                      v-model="telPrincipal" placeholder="Numero"></b-form-input>
                    <label class="mt-3" for="wppP">Whatsapp</label>
                    <b-form-checkbox id="wppP" v-model="wppPrincipal" name="check-button" switch>
                    </b-form-checkbox>
                  </b-card>
                </b-col>
                <b-col>
                  <b-card>
                    <span>*</span> Telefone para Recado:
                    <b-form-input class="mt-3" v-mask="['(##) ####-####', '(##) #####-####']" id="telefone1"
                      v-model="telRecado" placeholder="Numero"></b-form-input>
                    <label class="mt-3" for="wppR">Whatsapp</label>
                    <b-form-checkbox id="wppR" v-model="wppRecado" name="check-button" switch>
                    </b-form-checkbox>
                  </b-card>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-button :disabled="loading" variant="success" @click="salvar()">
                  <b-spinner small v-if="loading" label="Loading..."></b-spinner>
                  <i class="fas fa-save"></i>
                  Salvar
                </b-button>
              </b-row>
            </b-skeleton-wrapper>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      distribuidor: {
        nome: ''
      },
      loading: false,
      responsavel: '',
      telPrincipal: '',
      telRecado: '',
      email: '',
      nascimento: '',
      erros: [],
      cpf: '',
      wppPrincipal: false,
      wppRecado: false,
      firstLoading: false
    }
  },
  computed: {
    emailState() {
      if (this.email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(this.email);
      }
    },
    cpfState() {
      if (!this.cpf) return;
      let strCPF = this.cpf.replace(/[^0-9]/g, '')
      var Soma = 0;
      var i = 0;
      var Resto;
      if (strCPF == "00000000000" || strCPF.length < 11) return false;
      if (strCPF.length != 11 ||
        strCPF == "00000000000" ||
        strCPF == "11111111111" ||
        strCPF == "22222222222" ||
        strCPF == "33333333333" ||
        strCPF == "44444444444" ||
        strCPF == "55555555555" ||
        strCPF == "66666666666" ||
        strCPF == "77777777777" ||
        strCPF == "88888888888" ||
        strCPF == "99999999999")
        return false;

      for (let i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
      Resto = (Soma * 10) % 11;

      if ((Resto == 10) || (Resto == 11)) Resto = 0;
      if (Resto != parseInt(strCPF.substring(9, 10))) return false;

      Soma = 0;
      for (i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
      Resto = (Soma * 10) % 11;

      if ((Resto == 10) || (Resto == 11)) Resto = 0;
      if (Resto != parseInt(strCPF.substring(10, 11))) return false;
      return true;
    },
  },
  methods: {
    salvar() {
      const vm = this;
     

      if (!vm.validaForm()) {
        let er = '<ul>';
        vm.erros.forEach((el) => {
          er += '<li>' + el + '</li><br>'
        })

        er += '</ul>';
        vm.$swal.fire({
          title: 'Atenção!',
          icon: 'error',
          text: 'erro ao salvar!',
          html: er
        })
        return
      }
      vm.loading = true;
      const data = {
        id: this.distribuidor.id,
        nome: this.responsavel,
        telPrincipal: this.telPrincipal,
        wppPrincipal: this.wppPrincipal,
        telRecado: this.telRecado,
        wppRecado: this.wppRecado,
        email: this.email,
        nascimento: this.nascimento,
        cpf: this.cpf
      }
      //console.log("salvando", data)
      axios
        .post('/distribuidor/atualizar', data)
        .then((response) => {
          //console.log(response);
          window.location.reload();
        }).catch((erro) => {
          console.log(erro.response);
          vm.$swal.fire({
            title: 'Atenção!',
            icon: 'error',
            text: 'Erro ao salvar dados!'
          })
        }).finally(() => {
          vm.loading = false;
        })
    },
    validaForm() {
      this.erros = [];
      if (!this.responsavel || this.responsavel.length < 5) {
        this.erros.push('Nome do responsável inválido');
      }
      if (!this.cpf || !this.cpfState) {
        this.erros.push('CPF inválido');
      }
      if (!this.nascimento) {
        this.erros.push('Data de nascimento inválida');
      }
      if (!this.telPrincipal || this.telPrincipal.length < 14) {
        this.erros.push('Telefone principal inválido');
      }
      if (!this.telRecado || this.telRecado.length < 14) {
        this.erros.push('Telefone para recado inválido');
      }
      if(this.telRecado && this.telPrincipal && this.telRecado == this.telPrincipal){
        this.erros.push('Telefones devem ser diferentes')
      }
      if (!this.email || !this.emailState) {
        this.erros.push('E-mail inválido');
      }
      

      if (this.erros.length > 0) {
        return false;
      }

      return true;
    },
    getDistribuidor() {
      const vm = this;
      vm.firstLoading = true
      axios
        .get('/distribuidor/get')
        .then((response) => {
          if (response.data) {
            vm.distribuidor = response.data;
           // console.log(vm.distribuidor);
          } else {
            vm.$swal.fire({
              title: 'Atenção!',
              icon: 'warning',
              text: 'Erro ao buscar distribuidor',
            })
          }
        }).catch((erro) => {
          console.log(erro);
          vm.$swal.fire({
            title: 'Atenção!',
            icon: 'warning',
            text: 'Erro ao buscar distribuidor',
          })
        }).finally(() => {
          vm.firstLoading = false
        })
    }
  },
  mounted() {
    this.getDistribuidor();
  },
}
</script>

<style>
button {
  width: 100%;
  background-color: #4CAF50;
  color: white;
  padding: 14px 20px;
  margin: 8px 0;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
button:hover {
  background-color: #45a049;
  box-shadow: black;
}
span {
  color: red;
}


@media (max-width: 1000px) {
  .logo {
    display: none;
  }

  .title {
    text-align: justify;
    font-size: 18px;
  }

  .distribuidor {
    text-align: center;
    font-size: 20;
  }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/distribuidor/Home/atualizacao.vue